import { render, staticRenderFns } from "./FacPods.vue?vue&type=template&id=285384d8&"
import script from "./FacPods.vue?vue&type=script&lang=js&"
export * from "./FacPods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports